import React from "react";
import BlockeInsurancetable from "./blockedInsuranceTable";
import Sidebar from "../../../components/sidebar/Sidebar";
import Navbar from "../../../components/navbar/Navbar";

const BlockedInsuranceContainer = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <BlockeInsurancetable />
      </div>
    </div>
  )
}

export default BlockedInsuranceContainer;
